// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';

import { MrInputSelect, MrInputSelectDeprecated } from '@ion/components';

import { useConsentCategoriesContext } from '../../context/consent-categories-context';

const legalDisclaimer =
  'We recommend that you consult with your legal team when determining your consent requirements.';

export const ConsentCategorySelect = ({
  onChange,
  helperText = legalDisclaimer,
  deprecatedSelect = false,
  ...props
}) => {
  const { consentCategories } = useConsentCategoriesContext();
  const consentCategoriesOptions = consentCategories?.map(category => {
    return {
      value: category.id,
      text: category.displayName,
    };
  });

  if (props.addEmptyValue === true) {
    consentCategoriesOptions.unshift({
      value: '',
      text: 'No Consent Category',
    });
  }
  const SelectComponent = deprecatedSelect ? MrInputSelectDeprecated : MrInputSelect;

  return (
    <SelectComponent
      placeholder="Select Consent Categories"
      testId="consentCategoriesSelect"
      name="consentCategories"
      options={consentCategoriesOptions}
      onChange={onChange}
      helperText={helperText}
      {...props}
    />
  );
};
ConsentCategorySelect.propTypes = {
  onChange: pt.func.isRequired,
  addEmptyValue: pt.bool,
  helperText: pt.string,
  deprecatedSelect: pt.bool,
};
